import initSelect from './select';
import pricingTariffDescriptions from './pricingTariffDescriptions';

export default function landingTariffs() {
  const tabs = [...document.querySelectorAll('.js-tariffs__period-tab')];
  const panels = [...document.querySelectorAll('.js-tariffs__panel')];
  const cardRadios = [
    ...document.querySelectorAll('.js-tariffs__card-radio')
  ];
  if (!tabs.length || !panels.length) return;
  const refreshDescriptions = pricingTariffDescriptions();

  const periodSelect = initSelect(
    document.querySelector('.tariffs__mobile-period .js-ui-select'),
    (periodId) => {
      const tab = tabs.find((item) => item.dataset.period === periodId);
      if (tab) selectPeriod(tab);
    }
  );

  function selectPeriod(selectedTab) {
    const selectedPeriod = selectedTab.dataset.period;

    tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.classList.toggle('tariffs__period-tab--active', isSelected);
      tab.setAttribute('aria-selected', String(isSelected));
      tab.tabIndex = isSelected ? 0 : -1;
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.period !== selectedPeriod;
    });

    periodSelect?.setValue(selectedPeriod);
    refreshDescriptions();
  }

  function selectCard(selectedCardRadio) {
    const panel = selectedCardRadio.closest('.js-tariffs__panel');
    if (!panel) return;

    panel.querySelectorAll('.tariffs__card').forEach((card) => {
      card.classList.remove('tariffs__card--featured');
    });
    selectedCardRadio
      .closest('.tariffs__card')
      ?.classList.add('tariffs__card--featured');
  }

  tabs.forEach((tab, index) => {
    tab.tabIndex = index === 0 ? 0 : -1;
    tab.addEventListener('click', () => selectPeriod(tab));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      let nextIndex = index;

      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;

      tabs[nextIndex].focus();
      selectPeriod(tabs[nextIndex]);
    });
  });

  selectPeriod(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);

  cardRadios.forEach((cardRadio) => {
    cardRadio.addEventListener('change', () => {
      if (cardRadio.checked) selectCard(cardRadio);
    });
  });
}
